import { SHOW_SPARKED_MARKER,  HIDE_SPARKED_MARKER} from "./sparkedMarkerReducer"

export const showSparkedMarker = (position) => ({
    type: SHOW_SPARKED_MARKER,
    payload: position
})

export const hideSparkedMarker = () => ({
    type: HIDE_SPARKED_MARKER,
})